module.exports = __webpack_public_path__ + "public/images/play.362c34db3e5990ba97be748cdeda2e0f.svg";